"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNodesByApplicationMode = filterNodesByApplicationMode;
const QuestionnaireVisitor_1 = __importDefault(require("../QuestionnaireVisitor"));
const structure_1 = require("../structure");
class FilterNodesByApplicationModeVisitor extends QuestionnaireVisitor_1.default {
    applicationModes;
    constructor(applicationModes) {
        super();
        this.applicationModes = applicationModes;
    }
    visitFieldGroup(fieldGroup) {
        fieldGroup.fields = this.filterNodesByApplicationMode(fieldGroup.fields);
        super.visitFieldGroup(fieldGroup);
    }
    filterNodesByApplicationMode(nodes) {
        return nodes.filter((node) => this.nodeMatchesApplicationMode(node));
    }
    nodeMatchesApplicationMode(baseNode) {
        if (!(0, structure_1.isField)(baseNode)) {
            return true;
        }
        if (!baseNode.applicationModes?.length) {
            return true;
        }
        return baseNode.applicationModes.some((nodeMode) => this.applicationModes.includes(nodeMode));
    }
}
function filterNodesByApplicationMode(questionnaire, applicationModes) {
    if (!applicationModes.length) {
        return questionnaire;
    }
    const visitor = new FilterNodesByApplicationModeVisitor(applicationModes);
    const { questionnaire: filteredQuestionnaire } = visitor.visitQuestionnaire(questionnaire);
    return filteredQuestionnaire;
}
